module.exports = "<section-header contents=\"{\n    state: $ctrl.contents.state,\n    iconClass: 'fa-group',\n    title: 'Assist others',\n    description: 'Share your knowledge, learn from how others have done'\n}\"></section-header> ";


//////////////////
// WEBPACK FOOTER
// .-dna/app/sections/assist/assist.section-header.html
// module id = 4139
// module chunks = 86